<script>
import { postPaged } from '@/services/paginated';
import axios from 'axios';

let user = JSON.parse(localStorage.getItem('user'));

export default {
  data() {
    return {
      columns: [
        { label: 'Tên dịch vụ', field: 'name', width: '320px' },
        { label: 'Loại dịch vụ', field: 'type', width: '240px' },
        { label: 'Hành động', field: '_id', width: '160px' },
      ],
      rows: [],
      totalRows: 0,
      page: 1,
      perPage: 10,
      searchTerm: '',
      isLoading: false,
    };
  },

  async created() {
    if (user) {
      await this.fetchRows();
    }
  },

  methods: {
    /** Gọi API lấy danh sách dịch vụ (phân trang server-side) */
    async fetchRows() {
      this.isLoading = true;
      try {
        const { items, total } = await postPaged('/service/list', {
          page: this.page,
          limit: this.perPage,
          search: this.searchTerm,
        });
        this.rows = Array.isArray(items) ? items : [];
        this.totalRows = typeof total === 'number' ? total : 0;
      } catch (err) {
        console.error('Lỗi tải danh sách dịch vụ:', err);
        this.rows = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },

    /** Đổi trang */
    onPageChange({ currentPage }) {
      this.page = currentPage || 1;
      this.fetchRows();
    },

    /** Đổi số dòng / trang */
    onPerPageChange({ currentPerPage }) {
      this.perPage = currentPerPage || 10;
      this.page = 1;
      this.fetchRows();
    },

    /** Tìm kiếm server-side */
    onSearch({ searchTerm }) {
      this.searchTerm = searchTerm || '';
      this.page = 1;
      this.fetchRows();
    },


    del(_id) {
      // stop here if form is invalid
      axios({
        url: process.env.VUE_APP_SERVER_URL + "/service/delete",
        method: "post",
        headers: {
          authorization: user.token,
        },

        data: {
          _id: _id,
        },
      })
        .then(({ data }) => {
          this.$toasted.success("Xóa thành công");
        })
        .catch((error) => {
          this.$toasted.error("có lỗi khi xóa");
        });
    },
    edit(row) {
      switch (row.type) {
        case 1:
          this.$router.push({
            name: "service-us-vn",
            query: {
              id: row._id,
            },
          });
          break;
        case 2:
          this.$router.push({
            name: "service-vn-us",
            query: {
              id: row._id,
            },
          });
          break;
        case 3:
          this.$router.push({
            name: "service-us-us",
            query: {
              id: row._id,
            },
          });
          break;
        case 4:
          this.$router.push({
            name: "service-seaway",
            query: {
              id: row._id,
            },
          });
          break;
        case 5:
          this.$router.push({
            name: "service-money",
            query: {
              id: row._id,
            },
          });
          break;
        case 6:
          this.$router.push({
            name: "service-buy-store",
            query: {
              id: row._id,
            },
          });
          break;
        case 7:
          this.$router.push({
            name: "service-shopping",
            query: {
              id: row._id,
            },
          });
      }
    }
    
  }
};
</script>

<template>
  <div class="mb-5">
    <div>
      <h3 class="h5">Danh sách dịch vụ</h3>
      <hr />
    </div>

    <vue-good-table :columns="columns" :rows="rows" :total-rows="totalRows" :pagination-options="{
      enabled: true,
      rowsPerPageLabel: 'mục/trang',
      nextLabel: 'Trang sau',
      prevLabel: 'Trang trước',
      mode: 'records',
      perPage: perPage,
      perPageDropdown: [10, 20, 50],
      allLabel: 'Tất cả',
    }" :line-numbers="true" :search-options="{ enabled: true }" mode="remote" @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange" @on-search="onSearch">
      <template slot="table-row" slot-scope="props">
        <!-- Cột hành động -->
        <span v-if="props.column.field == '_id'">
          <button
            type="button"
            @click="edit(props.row)"
            class="btn btn-primary btn-sm mx-2"
          >
            Sửa
          </button>
    
        </span>

        <!-- Hiển thị loại dịch vụ dễ đọc -->
        <span v-else-if="props.column.field === 'type'">
          <span v-if="props.row.type === 1">US→VN</span>
          <span v-else-if="props.row.type === 2">VN→US</span>
          <span v-else-if="props.row.type === 3">US↔US</span>
          <span v-else-if="props.row.type === 4">Đường Tàu</span>
          <span v-else-if="props.row.type === 5">Chuyển Tiền</span>
          <span v-else-if="props.row.type === 6">Mua Hộ & Lưu Kho</span>
          <span v-else-if="props.row.type === 7">Mua Hàng</span>
          <span v-else>Khác</span>
        </span>

        <!-- Mặc định -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<style scoped>
.vgt-table td,
.vgt-table th {
  white-space: nowrap;
  vertical-align: middle;
}
</style>
